import React, { useState, useEffect } from 'react'
import correctIcon from '../../../../images/correct.svg'
import NotQuiteIcon from '../../../../images/notQuite.svg'
import IncorrectIcon from '../../../../images/incorrect.svg'
import { Grid, Typography } from '@material-ui/core'
import styles from './styles'
import withStyles from '@material-ui/core/styles/withStyles'

const QuizAnswer = ({ questionAnswer, submitPart2, setAnsweredCorrectlyStep2, answeredCorrectlyStep2,  selectedOption, classes, moved, showBriefness }) => {

  const [answerImage, setAnswerImage] = useState("")
  const [answerMessage, setAnswerMessage] = useState("")

  useEffect(() => {
    if(submitPart2 > 1){
      if(selectedOption === questionAnswer.step2.answer){
        setAnsweredCorrectlyStep2(true)
        setAnswerImage(correctIcon)
        setAnswerMessage("")
      }else{
        setAnsweredCorrectlyStep2(false)
        setAnswerImage(IncorrectIcon)
        setAnswerMessage("")
      }
    }else{
      whatWasMoved()
    }
  }, [moved])

  const whatWasMoved = () => {
    console.log("moved", moved)
    switch (moved) {
      case 'nothing':
        setAnswerImage(IncorrectIcon)
        setAnswerMessage("")
        return
      case 'correct':
        setAnswerImage(correctIcon)
        setAnswerMessage("")
        return
      case "incorrect":
        setAnswerImage(IncorrectIcon)
        setAnswerMessage("")
        return
      case "moved demand curve but in opposite":
        setAnswerImage(NotQuiteIcon)
        setAnswerMessage("You were right to shift the demand curve, but you did it in the wrong direction.")
        return
      case "moved supply curve but in opposite":
        setAnswerImage(NotQuiteIcon)
        setAnswerMessage("You were right to shift the supply curve, but you did it in the wrong direction.")
        return
    }
  }

  const answerPrefix = () => {
    if (questionAnswer.graphType === "supply curve") {
      return !questionAnswer.answer.includes('Nothing') && (questionAnswer.answer.includes('shifts') ? 'Supply curve ' : 'Quantity supplied ')
    } else {
      return !questionAnswer.answer.includes('Nothing') && (questionAnswer.answer.includes('shifts') ? 'Demand curve ' : 'Quantity demanded ')
    }
  }

  return (
    <Grid className={classes.answerContainer}>
      {submitPart2 > 1 ?
        <>
          <Typography variant='h5' className={classes.QuestionTextAgain}>
            Q. {questionAnswer.step2.question}
            <br/>
            {questionAnswer.step2.followUpQuestion}
          </Typography>
          <img src={answerImage} className={classes.correctIncorrectIcon} />
            <Typography variant='h4' className={classes.curveShiftingText}>
              {questionAnswer.step2.answerText}
            </Typography>
          {showBriefness && <Typography variant='h5' className={classes.briefNessHeading}>
            {answerMessage}
          </Typography>}
          <Typography variant='h5' className={classes.briefNess}>
            {questionAnswer.step2.explanation}
          </Typography>
        </>
        :
        <>
          <Typography variant='h5' className={classes.QuestionTextAgain}>
            Q. {questionAnswer.question}
            <br/>
            {questionAnswer.subQuestion}
          </Typography>
          <img src={answerImage} className={classes.correctIncorrectIcon} />
          <Typography variant='h4' className={classes.curveShiftingText}>
            {/* {answerPrefix()} */}
            {questionAnswer.answer}
          </Typography>
          {showBriefness && <Typography variant='h5' className={classes.briefNessHeading}>
            {answerMessage}
          </Typography>}
          <Typography variant='h5' className={classes.briefNess}>
            {questionAnswer.briefness}
          </Typography>
        </>
      }
    </Grid>
  )
}

export default withStyles(styles)(QuizAnswer)
